module.exports = TencentCaptcha;